import React from 'react';
import * as serviceTypes from '../../../data/booking/constants/service_types';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import { Desktop, Mobile } from '../../shared/components/Responsive';
import * as ItemDesktop from '../components/ServiceItem';
import * as ItemMobile from '../components/ServiceItemMobile';
import { formatCurrency } from '../../../data/shared/money';
import {withTranslation} from "react-i18next";
import {PENDING_QUOTATION} from "../../../data/booking/constants/quotation_status";
// import Tooltip from "ui/shared/components/Tooltip";
import {NoSymbolIcon, PencilSquareIcon, PlusCircleIcon} from "@heroicons/react/24/outline";
import cx from "classnames"

const ServiceItem = ({ service, item, Component }) => {
    switch (service.type) {
        case serviceTypes.BAG_TRANSPORT:
            return <Component.BagTransport service={service} item={item} />;
        case serviceTypes.BIKE_TRANSPORT:
            return <Component.BikeTransport service={service} item={item} />;
        case serviceTypes.PEOPLE_TRANSPORT:
            return <Component.PeopleTransport service={service} item={item} />;
        case serviceTypes.REGULAR_SHUTTLE:
            return <Component.RegularShuttle service={service} item={item} />;
        case serviceTypes.CAR_TRANSPORT:
            return <Component.CarTransport service={service} item={item} />;
        case serviceTypes.ROADBOOK_MHIKES:
            return <Component.RoadbookMhikes service={service} item={item} />;
        case serviceTypes.CUSTOM:
            return <Component.Custom service={service} item={item} />;
        case serviceTypes.CANCELLATION:
            return <Component.Cancellation service={service} item={item} />;
        case serviceTypes.CAR_PARKING:
            return <Component.CarParking service={service} item={item} />;
    }

    return null;
};


const Service = ({ service, t }) => {

    return <section className="recap-item">
        <div className="item-header">
            <div className="service-picto">
                <img className="service-icon" src={'/assets/img/icons/services/b-' + service.type + '.png'}/>
            </div>

            <hgroup className="service-description">
                <h2 className="first-line !text-sm sm:!text-[18px]">{serviceTypes.serviceName(service.type)} :</h2>
                <h3 className="second-line">
                    {(has(service, 'route') && !isEmpty(service.route)) && service.route.label + ' / '}
                    {service.summary}
                </h3>
            </hgroup>
        </div>

        <div className="step-list">
            <Desktop>
                {service.items.map(item => <div key={item.id} className={cx("relative", {
                            'border rounded p-1 pb-0 my-1 bg-white': item.updateStatus,
                            'border-red-400': item.updateStatus == 'deleted',
                            'border-orange-400': item.pendingItem?.updateStatus == 'edited',
                            'border-blue-400': item.updateStatus == 'added'
                        })}>
                            <ServiceItem
                                service={service}
                                item={item}
                                Component={ItemDesktop}
                            />
                            {item.pendingItem && <ServiceItem
                                service={service}
                                item={item.pendingItem}
                                Component={ItemDesktop}
                            />}
                            {item.updateStatus && <span className="absolute -top-2 -right-2 text-slate-50 text-sm">
                                {item.updateStatus == 'added' &&
                                    <p className={'bg-blue-400 rounded-lg flex p-1 pr-2'}><PlusCircleIcon
                                        className="w-5 h-5 mr-1"/>{t('booking.update.added')}</p>}
                                {item.pendingItem?.updateStatus == 'edited' &&
                                    <p className={'bg-orange-400 rounded-lg flex p-1 pr-2'}><PencilSquareIcon
                                        className="w-5 h-5 mr-1"/>{t('booking.update.edited')}</p>}
                                {item.updateStatus == 'deleted' &&
                                    <p className={'bg-red-500 rounded-lg flex p-1 pr-2'}><NoSymbolIcon
                                        className="w-5 h-5 mr-1"/>{t('booking.update.deleted')}</p>}
                </span>}
        </div>
        )}
    </Desktop>

        <Mobile>
                {service.items.map(item =><div key={item.id} className={cx("relative", {
                    'border rounded p-1 pb-0 my-1 bg-white': item.updateStatus,
                    'border-red-400': item.updateStatus == 'deleted',
                    'border-orange-400': item.pendingItem?.updateStatus == 'edited',
                    'border-blue-400': item.updateStatus == 'added'
                })}>
                    <ServiceItem
                        key={item.id}
                        service={service}
                        item={item}
                        Component={ItemMobile}
                    />
                    {item.pendingItem && <ServiceItem
                        service={service}
                        item={item.pendingItem}
                        Component={ItemMobile}
                    />}
                        {item.updateStatus && <span className="absolute -top-2 -right-2 text-slate-50 text-sm">
                                {item.updateStatus == 'added' &&
                                    <p className={'bg-blue-400 rounded-lg flex p-1 pr-2'}><PlusCircleIcon
                                        className="w-5 h-5 mr-1"/>{t('booking.update.added')}</p>}
                            {item.pendingItem?.updateStatus == 'edited' &&
                                <p className={'bg-orange-400 rounded-lg flex p-1 pr-2'}><PencilSquareIcon
                                    className="w-5 h-5 mr-1"/>{t('booking.update.edited')}</p>}
                            {item.updateStatus == 'deleted' &&
                                <p className={'bg-red-500 rounded-lg flex p-1 pr-2'}><NoSymbolIcon
                                    className="w-5 h-5 mr-1"/>{t('booking.update.deleted')}</p>}
                </span>}
                    </div>
                )}
            </Mobile>

            {service.status != PENDING_QUOTATION && null !== service.price &&
                <div className="wb-line total-line subtotal">
                    <div className="wb-cell main-cell">{t('followup.subtotal')} :</div>
                    <div className="wb-cell price">{formatCurrency(service.price)}</div>
                </div>
            }

            {null !== service.discount && service.discount.length > 0 && <div className="wb-line total-line total-ht subtotal-discount">
                <div className="wb-cell main-cell">
                    Remise {service.discount[0].label}
                </div>
                <div className="wb-cell price">
                    - {formatCurrency(service.discount[0].value)}
                </div>
            </div>}

        </div>
    </section>
}
;

export default withTranslation()(Service);
